module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "135",
      "src": "images/co.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/int"
    }
  }, [_vm._v("Introduction: On Your Own")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("Part 1. Getting through the Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1. Setting Goals and Priorities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("2. Getting Organized")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02"
    }
  }, [_vm._v("Part 2. Money, Money, Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_vm._v("3. Budgeting 101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04"
    }
  }, [_vm._v("4. A Word about Debt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05"
    }
  }, [_vm._v("5. Banking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06"
    }
  }, [_vm._v("6. Checking It Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07"
    }
  }, [_vm._v("7. Keeping Things Balanced")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08"
    }
  }, [_vm._v("8. How You Rate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09"
    }
  }, [_vm._v("9. The Taxman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03"
    }
  }, [_vm._v("Part 3. Getting Your Own Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10"
    }
  }, [_vm._v("10. Finding Home Sweet Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Before You Sign Anything")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Roomies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Treaties and Truces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Purchasing Your First Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Your First Mortgage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4. God and Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Making Time for God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Your Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Your Church, Your Part")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. What Isn’t a Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5. Other Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Creating Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Host(ess) with the Most(est)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Fun, Exciting, Cheap, and Legal Things to Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. When Sad Is Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. When You’re More Than Just Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 6. Wheels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Keys, Please")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. New, Used, or Leased")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Before You Go to the Car Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Car Insurance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Car Maintenance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Car Safety and Travel Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 7. Gotta Eat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Kitchen Basics—What You Need to Get Started")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. A Well-Stocked Pantry and Fridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Food, Glorious Food")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Menu Planning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Going to the Grocery Store—Without Your Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Good to Eat and Easy to Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 8. Staying Healthy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. To Life, Good Health, and Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. On the Move")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Germs and Junk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. What You Drink")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 9. I Don’t Feel So Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. When to Go to the Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. How to Choose a Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Your Personal and Family Health History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Health Insurance Options")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. First-Aid Kits: What You Should Have at Home and in Your Car")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Basic First Aid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 10. Dust Bunnies and the Sock Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Divide and Conquer (Laundry)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. The Things You Must Clean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Essential Cleaning Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. How to Clean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. A Routine to Stay Clean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 11. Wired")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Spiders on the Web")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Playing It Safe on the Web")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Passwords")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Techno Lingo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 12. Active Citizenship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. Registering to Vote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Making Your Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. What You’ll Vote For")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. You? Run for Office?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Active in Your Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. Law and Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 13. Important Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. Important Documents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. Emergency Contact List")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/inde",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5093abc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cona.vue
// module id = 72
// module chunks = 0